import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ForWhom() {
  const bullets = ['Trabajás y terminás el día agotada', 'Estudiás o te capacitás con la cabeza saturada', 'Sentís que la casa te drena energía', 'Vivís con la batería en rojo casi siempre', 'Querés alivio, no exigirte más'];
  return <Section background="light-peach" containerSize="md" className="text-center" data-id="element-110">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-111">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-10" data-id="element-112">
          ENERGÍA REAL es para vos si…
        </h2>

        <div className="space-y-4 max-w-2xl mx-auto text-left" data-id="element-113">
          {bullets.map((bullet, index) => <motion.div key={index} className="bg-white p-5 rounded-xl border border-rose-200 shadow-sm flex items-start gap-4" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-114">
              <div className="bg-rose-100 p-1.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-115">
                <Check className="w-4 h-4 text-rose-600" strokeWidth={3} data-id="element-116" />
              </div>
              <p className="text-lg font-medium text-slate-800" data-id="element-117">{bullet}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </Section>;
}